'use client';

import classNames from '@sindresorhus/class-names';

import '@web-catalog/styles/globals.scss';

import Error from './error';
import styles from './global-error.module.scss';
import {vkFontClassNames} from './vkFont';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function GlobalError({error}: {error: any}) {
  return (
    <html>
      <body
        className={classNames(
          vkFontClassNames,
          /* почему-то не подтягиваются стили от components/Layout */
          styles.fixMissingStyle,
        )}
      >
        <Error
          error={error}
          hideSearchButton={
            /**
             * в этом состоянии роутера нет, попытки пользоваться поиском будут приводить к
             * invariant expected app router to be mounted
             */
            true
          }
        />
      </body>
    </html>
  );
}
